import BaseAPIService from '../base/base-api-service';
import CreditCardInfoModel from 'src/model/creditCardInfo.model';

interface IDeleteCreditCardInfoData {
  cardToken: string;
  cardType: string;
}

interface IPatchCreditCardInfoData {
  cardHolderAddress1: string;
  cardHolderAddress2: string;
  cardToken: string;
  cardType: string;
  city: string;
  expirationDate: string;
  holderStateZip: string;
}

class EditOrDeleteCreditCardService extends BaseAPIService<
  CreditCardInfoModel
> {
  public endpoint: string = '/cartapp/v1/creditcard/savedCards/info';

  constructor() {
    super(CreditCardInfoModel);
  }

  public getSavedCreditCardsInfo(): Promise<CreditCardInfoModel[]> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: this.endpoint
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public deleteCreditCardsInfo(data: IDeleteCreditCardInfoData) {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'DELETE',
      url: this.endpoint,
      data
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public updateCreditCardsInfo(data: IPatchCreditCardInfoData) {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'PATCH',
      url: this.endpoint,
      data
    });
  }
}

const EditOrDeleteCreditCardServiceInstance = new EditOrDeleteCreditCardService();
Object.freeze(EditOrDeleteCreditCardServiceInstance);

export default EditOrDeleteCreditCardServiceInstance;
